import CrudRequest from 'Domain/CrudRequest';
import HttpService from 'Support/services/HttpService';
import router from '../../router';

class RepurchaseLoteRequest extends CrudRequest {
  static baseUrl() {
    return '/v1/recompra';
  }

  static list(queryParams = {}) {
    const id = router.currentRoute.params ? router.currentRoute.params.id : null;
    return HttpService.get(`${this.baseUrl()}/lote/findById/${id}`, {
      params: queryParams,
    });
  }
}

export default RepurchaseLoteRequest;
